import { differenceInDays } from "date-fns";
import { useTranslation } from "react-i18next";

import * as yup from "yup";
export const appl73ValidationSchema = () => {
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      acceptedFinancialReport: yup
        .string()
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      pastApp: yup
        .object()
        .shape({ m02_id: yup.string(), label: yup.string() })
        .nullable()
        .default(undefined)
        .transform((value, originalValue) => {
          if (
            originalValue &&
            typeof originalValue === "object" &&
            Object.keys(originalValue).length === 0
          ) {
            return undefined;
          }
          return value;
        }),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      docPraktDSDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPraktDS: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      dlp: yup.string().nullable(),
      auditCompanies: yup
        .array()
        .of(
          yup
            .object()
            .shape({ compGemi: yup.string(), compName: yup.string() }),
        ),
      usageFromDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      usageToDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      auditPersons: yup.array().of(
        yup.object().shape({
          afm: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          firstName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          lastName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          fathersName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          auditorType: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          auditorKind: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
      ),
      auditNewPersons: yup.array().of(
        yup.object().shape({
          afm: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          firstName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          lastName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          fathersName: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          birthYear: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          city: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          auditorType: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          auditorKind: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          foreas: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
          elteNumber: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
        }),
      ),
    })
    .test(
      "balance dates must me max year apart",
      t(
        "Ελέγξτε τις ημερομηνίες χρήσης. Η ημερομηνία έναρξης χρήσης πρέπει να απέχει το πολύ ένα χρόνο από την ημερομηνία λήξης.",
      ),
      (value) => {
        const { usageFromDate, usageToDate } = value;
        return (
          0 <= differenceInDays(usageToDate, usageFromDate) &&
          differenceInDays(usageToDate, usageFromDate) <= 365
        );
      },
    )
    .test(
      "has entered auditor",
      t("Προσοχή! Δεν έχετε δηλώσει κάποια ελεγκτική εταιρεία ή ελεγκτή."),
      (value) => {
        return (
          (value?.auditCompanies?.length &&
            value?.auditCompanies?.length > 0) ||
          (value?.auditPersons?.length && value?.auditPersons?.length > 0) ||
          (value?.auditNewPersons?.length && value?.auditNewPersons?.length > 0)
        );
      },
    );
};
